import { api as deliveryApi, configs as deliveryConfigs } from './delivery'
import useItem, { itemConfigs } from './useItem'
import useItemByDaypart, { itemByDaypartConfigs } from './useItemByDaypart'
import {
  itemWowGrowthByQuantityConfigs,
  itemWowGrowthBySalesConfigs,
  useBottomItemWowGrowthByQuantity,
  useBottomItemWowGrowthBySales,
  useTopItemWowGrowthByQuantity,
  useTopItemWowGrowthBySales,
} from './useItemWowGrowth'
import useLocationDayPart, {
  locationDayPartConfigs,
} from './useLocationDayPart'
import useLocationDiscountComp, {
  locationDiscountCompConfigs,
} from './useLocationDiscountComp'
import useLocationGroupDayPart, {
  locationGroupDayPartConfigs,
} from './useLocationGroupDayPart'
import useLocationGroupInventory, {
  locationGroupInventoryConfigs,
} from './useLocationGroupInventory'
import useLocationGroupRevenueCenter, {
  locationGroupRevenueCenterConfigs,
} from './useLocationGroupRevenueCenter'
import useLocationLaborOverview, {
  locationLaborOverviewConfigs,
} from './useLocationLaborOverview'
import useLocationPurchase, {
  locationPurchaseConfigs,
} from './useLocationPurchase'
import useLocationRevenueCenter, {
  locationRevenueCenterConfigs,
} from './useLocationRevenueCenter'
import useMadeFromScratch, {
  madeFromScratchConfigs,
} from './useMadeFromScratch'
import useMadeFromScratchSummary, {
  madeFromScratchSummaryConfigs,
} from './useMadeFromScratchSummary'
import useManageLocationGroups, {
  manageLocationGroupsConfigs,
} from './useManageLocationGroups'
import useManageLocations, {
  manageLocationsConfigs,
} from './useManageLocations'
import usePAndL, { pAndLConfigs } from './usePAndL'
import usePAndLRankings, { pAndLRankingsConfigs } from './usePAndLRankings'
import useR365Locations, { r365LocationsConfigs } from './useR365Locations'

export const configs = {
  ...deliveryConfigs,
  itemByDaypart: itemByDaypartConfigs,
  madeFromScratch: madeFromScratchConfigs,
  madeFromScratchSummary: madeFromScratchSummaryConfigs,
  locationGroupDayPart: locationGroupDayPartConfigs,
  locationGroupRevenueCenter: locationGroupRevenueCenterConfigs,
  topItemWowGrowthByQuantity: itemWowGrowthByQuantityConfigs,
  bottomItemWowGrowthByQuantity: itemWowGrowthByQuantityConfigs,
  topItemWowGrowthBySales: itemWowGrowthBySalesConfigs,
  bottomItemWowGrowthBySales: itemWowGrowthBySalesConfigs,
  item: itemConfigs,
  locationDayPart: locationDayPartConfigs,
  locationRevenueCenter: locationRevenueCenterConfigs,
  locationDiscountComp: locationDiscountCompConfigs,
  locationLaborOverview: locationLaborOverviewConfigs,
  locationGroupInventory: locationGroupInventoryConfigs,
  locationPurchase: locationPurchaseConfigs,
  manageLocations: manageLocationsConfigs,
  manageLocationGroups: manageLocationGroupsConfigs,
  pAndL: pAndLConfigs,
  pAndLRankings: pAndLRankingsConfigs,
  r365Locations: r365LocationsConfigs,
}

export const api = {
  ...deliveryApi,
  itemByDaypart: useItemByDaypart,
  madeFromScratch: useMadeFromScratch,
  madeFromScratchSummary: useMadeFromScratchSummary,
  locationGroupDayPart: useLocationGroupDayPart,
  locationGroupRevenueCenter: useLocationGroupRevenueCenter,
  topItemWowGrowthByQuantity: useTopItemWowGrowthByQuantity,
  bottomItemWowGrowthByQuantity: useBottomItemWowGrowthByQuantity,
  topItemWowGrowthBySales: useTopItemWowGrowthBySales,
  bottomItemWowGrowthBySales: useBottomItemWowGrowthBySales,
  item: useItem,
  locationDayPart: useLocationDayPart,
  locationRevenueCenter: useLocationRevenueCenter,
  locationDiscountComp: useLocationDiscountComp,
  locationLaborOverview: useLocationLaborOverview,
  locationGroupInventory: useLocationGroupInventory,
  locationPurchase: useLocationPurchase,
  manageLocations: useManageLocations,
  manageLocationGroups: useManageLocationGroups,
  pAndL: usePAndL,
  pAndLRankings: usePAndLRankings,
  r365Locations: useR365Locations,
}
